import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
// import logo from 'assets/img/illustrations/falcon.png';
import logoCorectic from 'assets/corectic/images/logo-corectic.svg';
import logoMyndrive from 'assets/corectic/images/logo-myndrive.png';

import { ClientContext } from 'context/Context';

const Logo = ({ at, height, className, textClass, ...rest }) => {
  
  const { clientConfig } = useContext(ClientContext);
  const logo = clientConfig?.logoIconData? clientConfig?.logoIconData : 
    (["console.myndrive.com"].includes(window.location.hostname)) ? logoMyndrive : logoCorectic;

  return (
    <Link
      to="/"
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-5 mb-4': at === 'auth'
          },
          className
        )}
      >
        <img id="bri-global-logo-image" className="me-2" src={logo} alt="Logo" height={height} />
        <span className={classNames('font-sans-serif', textClass)}>&nbsp;</span>
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string
};

Logo.defaultProps = { at: 'auth', width: 58 };

export default Logo;
